export default {"src":"/_next/static/media/unlink.8d85a9f0.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};